import EntregasContent from "./EntregasContent";

export default function Entregas() {
  return <EntregasContent />;
}
